// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2GKUf","modalFooterButton":"ModalNotes_modalFooterButton__CQWeb"};